var React = require("react");
var { withNamespaces } = require('react-i18next');

var ExperienceCounters = React.createClass({
  propTypes : {
    experience: React.PropTypes.object
  },

  formatedCount : function(count){
    if (count > 9) {
      return "9+"
    } else {
      return count.toString()
    }
  },

  totalChallengeCountText : function(total_challenge_count){
    const text = this.props.t('Challenge', {count: total_challenge_count})
    return `${total_challenge_count} ${text}`
  },

  unseenChallengeCountText : function(unseen_challenge_count){
    if (unseen_challenge_count > 0) {
      return (
        <span>
          &nbsp;|&nbsp;
          <span className="badge">
            {this.formatedCount(unseen_challenge_count)}
          </span> {this.props.t('New')}
        </span>
      )
    }
  },

  render : function(){
    const { total_challenge_count, unseen_challenge_count } = this.props.experience

    return (
      <div className="experience-card__counters">
        {this.totalChallengeCountText(total_challenge_count || 0)}
        {this.unseenChallengeCountText(unseen_challenge_count || 0)}
      </div>
    );
  }
});

module.exports = withNamespaces()(ExperienceCounters);



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/experience_counters.jsx